import { render, staticRenderFns } from "./DonorRecipient.vue?vue&type=template&id=5c36c432"
import script from "./DonorRecipient.vue?vue&type=script&lang=js"
export * from "./DonorRecipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports